import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-adverse-event-reporting',
    templateUrl: './adverse-event-reporting.component.html',
    styleUrls: ['./adverse-event-reporting.component.css'],
})
export class AdverseEventReportingComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<AdverseEventReportingComponent>) {}

    ngOnInit(): void {}

    close() {
        this.dialogRef.close();
    }
}
